// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3XioI","cell":"ColumnAccessor_cell__wNmNT","firstCellAccent":"ColumnAccessor_firstCellAccent__2yPkX"};